import {Component} from '@angular/core';

@Component({
    selector: 'db-hosting',
    templateUrl: './hosting.component.html',
    styleUrls: ['./hosting.component.scss'],
    standalone: false
})
export class HostingComponent {

  constructor() {}
}
